<template>
  <v-container id="home_menu" fluid tag="section">
    <!-- การแจ้งเตือนที่มีหน้าตา/ฟังก์ชันเฉพาะ (รอบรายงานบุคลากร, ค่าตอบแทนพนักงานราชการ) คงไว้ตามเดิม
         การแจ้งเตือนกำหนดการอื่นทั้งหมดย้ายไปอยู่ใน CollegeNotificationCenter ด้านล่าง -->
    <div>
      <Alert_personnel_report_rounds />
      <Alert_salary_gov v-if="period_college_80105.period_college_enable==='1' || period_college_80105.period_college_enable === 1" />
    </div>

    <v-card flat class="page-header-card mb-4">
      <v-card-text class="d-flex align-center flex-wrap pa-4">
        <div class="page-header-icon mr-3">
          <v-icon size="24" color="white">mdi-domain</v-icon>
        </div>
        <div class="mr-auto">
          <div class="page-header-title">เมนูหลักสถานศึกษา</div>
          <div class="page-header-subtitle grey--text text--darken-1">
            ผู้ใช้งานระบบ : {{ user.user_ID || "-" }} —
            {{ user.user_firstname }} {{ user.user_lastname || "" }}
          </div>
        </div>
        <v-chip
          color="success"
          text-color="white"
          v-if="user.user_status === 'active'"
        >
          กำลังใช้งาน
        </v-chip>
        <v-chip color="grey" text-color="white" v-else>
          {{ user.user_status || "-" }}
        </v-chip>
      </v-card-text>
    </v-card>

    <!-- ศูนย์แจ้งเตือน: ภารกิจตามกำหนดการ + สถานะทำรายการแล้ว (college_notification_center.php) -->
    <CollegeNotificationCenter @loaded="tasks = $event" />

    <DataQualityPanel class="mb-4" />

    <v-expansion-panels flat class="usage-guide-panel mb-4">
      <v-expansion-panel style="border: 1px solid #e4e4e7; border-radius: 10px;">
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="#263238">mdi-help-circle-outline</v-icon>
            <span class="font-weight-bold" style="color: #263238;">วิธีใช้หน้านี้ (สำหรับผู้รับผิดชอบใหม่)</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ol class="usage-steps">
            <li>
              ดู <strong>ศูนย์แจ้งเตือนภารกิจ</strong> ด้านบนก่อนทุกครั้ง — แท็บ “ต้องดำเนินการ”
              คืองานที่วิทยาลัยยังทำไม่ครบ เรียงงานเร่งด่วน/ใกล้ปิดไว้บนสุด
            </li>
            <li>
              กด <strong>“ขั้นตอนทำรายการ”</strong> เพื่อดูคู่มือทีละขั้น ว่าใครทำอะไร และระบบถือว่าเสร็จเมื่อใด
              แล้วกด <strong>“ดำเนินการ”</strong> เพื่อไปยังหน้าที่ต้องทำรายการ
            </li>
            <li>
              ภารกิจส่วนใหญ่ <strong>เปลี่ยนเป็น “ทำรายการแล้ว” เองอัตโนมัติ</strong> เมื่อบันทึก/แนบไฟล์ครบ
              ภารกิจที่ระบบตรวจเองไม่ได้ ให้กด <strong>“ยืนยันว่าทำรายการแล้ว”</strong> หลังทำเสร็จ
            </li>
            <li>
              เมนูทั้งหมดจัดเป็น <strong>กลุ่มงาน</strong> ด้านล่าง ค้นหาเมนูได้จากช่องค้นหา
              และกด “ขั้นตอนการทำงานของกลุ่มงานนี้” เพื่อดูลำดับงานทั้งรอบปี
            </li>
          </ol>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <CollegeWorkGroups :tasks="tasks" @video="openVideo" />

    <!-- V-model userdialog -->
    <v-layout row justify-center>
      <v-dialog v-model="adduserdialog" persistent max-width="80%">
        <v-card class="mx-auto pa-6" elevation="2">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="เปลี่ยนรหัสผ่าน"
            class="px-5 py-3 text_google"
            elevation="2"
          >
          </base-material-card>
          <v-card-text>
            <v-form ref="userform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    {{ user.user_name }} {{ user.user_firstname
                    }}{{ user.user_lastname }}
                  </v-flex>
                  <v-flex md12>
                    <v-text-field
                      outlined
                      label="รหัสผ่านปัจจุบัน"
                      v-model="old_password"
                      type="password"
                      required
                      :rules="[v => !!v || 'กรุณากรอกรหัสผ่านปัจจุบัน']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Password (อย่างน้อย 8 ตัวอักษร มีตัวอักษรและตัวเลข)"
                      v-model="user.user_password"
                      type="password"
                      :rules="passwordRules()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="user.user_confirmpassword"
                      type="password"
                      :rules="confirmPasswordRules(() => user.user_password)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large @click.stop="adduserdialog = false" rounded>
              <v-icon dark>mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn large color="warning" @click.stop="userSubmit()" rounded>
              <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeManageMovement"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/Tg9DjFm6SDM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeManageMovement = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeConditionbranch"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/iVZy90tWSZg"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeConditionbranch = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeAssessmentDevTeach"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/IuTKn-M-KGY"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeAssessmentDevTeach = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import Alert_personnel_report_rounds from "../../components/college/alert_personnel_report_rounds.vue";
import Alert_salary_gov from "../../components/gov_salary/alert_salary_gov.vue";
import DataQualityPanel from "../../components/college/DataQualityPanel.vue";
import CollegeNotificationCenter from "../../components/college/CollegeNotificationCenter.vue";
import CollegeWorkGroups from "../../components/college/CollegeWorkGroups.vue";
import { passwordRules, confirmPasswordRules } from "@/utils/passwordRules";
export default {
  components: {
    Alert_salary_gov,
    Alert_personnel_report_rounds,
    DataQualityPanel,
    CollegeNotificationCenter,
    CollegeWorkGroups
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      user: [],
      periods: [],
      old_password: "",
      // ภารกิจจากศูนย์แจ้งเตือน ใช้แสดงจำนวนงานค้างบนการ์ดกลุ่มงาน (เมนู/คู่มืออยู่ที่ collegeTaskCatalog.js)
      tasks: [],
      adduserdialog: false,
      VideoDialogYoutubeManageMovement: false,
      VideoDialogYoutubeConditionbranch: false,
      VideoDialogYoutubeAssessmentDevTeach: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      period_college_80105:[],
    };
  },

  async mounted() {
    try {
      await this.getuser();
      await this.period_collegeQuery();
    } catch (error) {
      console.error("home_menu mounted error:", error);
    }
  },

  methods: {
    passwordRules,
    confirmPasswordRules,
    async period_collegeQuery(){
      let result = await this.$http.post('period_college.php',{
        ApiKey:this.ApiKey,
        period_college_id:"80105"
      })
      this.period_college_80105=result.data
    },
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async getuser() {
      let result;
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      result = await this.$http.post("admin.php", {
        user_name: userSession.user_name,
        ApiKey: "HRvec2021"
      });
      this.user = result.data;
    },

    async VideoDialogAssessmentDev() {
      this.VideoDialogYoutubeAssessmentDevTeach = true;
    },

    async VideoDialogConditionB() {
      this.VideoDialogYoutubeConditionbranch = true;
    },
    async VideoDialogManageMove() {
      this.VideoDialogYoutubeManageMovement = true;
    },
    // วิดีโอจากการ์ดกลุ่มงาน (GROUPS[].video ใน collegeTaskCatalog.js)
    openVideo(id) {
      if (id === "iVZy90tWSZg") this.VideoDialogConditionB();
      else if (id === "IuTKn-M-KGY") this.VideoDialogAssessmentDev();
    },

    async userUpdate() {
      this.adduserdialog = true;
    },

    async userSubmit() {
      if (this.$refs.userform.validate()) {
        try {
          this.user.ApiKey = this.ApiKey;
          this.user.old_password = this.old_password;
          let result = await this.$http.post("user.update_password.php", this.user);
          if (result.data && result.data.status) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.adduserdialog = false;
            this.old_password = "";
            this.user.user_password = "";
            this.user.user_confirmpassword = "";
          } else {
            Swal.fire({
              icon: "warning",
              title: (result.data && result.data.message) || "ดำเนินการผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        } catch (error) {
          console.error("userSubmit error:", error);
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.listcontent {
  background-color: #750606;
  border-bottom: 3px solid #a86400;
  height: 100px;
}

/* Page header - เข้าชุดสีกรมท่ามาตรฐานเดียวกับหน้าอื่นๆ ที่ปรับปรุงแล้ว */
.page-header-card {
  border-radius: 14px !important;
  border: 1px solid #e4e4e7 !important;
  background: #ffffff !important;
}

.page-header-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #263238, #263238);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.page-header-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #263238;
  line-height: 1.3;
}

.page-header-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}

.usage-steps li {
  margin-bottom: 6px;
  line-height: 1.6;
}
</style>
